export function getClusterImageUrl(imgValue) {
    if (!imgValue) {
        return null;
    }

    if (imgValue.startsWith('http://') || imgValue.startsWith('https://')) {
        return imgValue;
    }

    const baseUrl = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');
    const path = imgValue.startsWith('/') ? imgValue : `/${imgValue}`;

    return `${baseUrl}/arquivos${path}`;
}
